import Splide from '@splidejs/splide';

// 呼び出し元 (views/welcome/index) はディスパッチャが turbolinks:load の中から呼ぶため、
// ここで改めて turbolinks:load を待つ必要はない。
// 以前は待っていたが、それはビューのインライン script がパース中に呼んでいた名残で、
// ディスパッチャ経由になると「turbolinks:load の処理中に turbolinks:load を購読する」形になり
// 初回表示でスライダーが初期化されなくなる (#2935)。
export default () => {
    const cardSliders = document.querySelectorAll('.js-card-slider');
    Array.from(cardSliders).forEach((cardSlider) => {
        new Splide(cardSlider, {
            rewind: true,
            perPage: 4,
            autoHeight: true,
            trimSpace: true,
            breakpoints: {
                768: {
                    perPage: 1,
                    pagination: false,
                    arrows: false,
                    padding: {
                        left: 0,
                        right: '6rem',
                    },
                },
            },
        }).mount();
    });
}
